import {
  Component,
  inject,
  signal,
  input,
  output
} from '@angular/core';
import {
  ButtonLoadingDirective,
  CardComponent,
  CardContentComponent,
  IconComponent,
} from '@gains-com/ui-angular';
import { AuthService } from '../../../../core/auth.service.js';
import { PurchaseDialogHeaderComponent } from '../purchase-dialog-header/purchase-dialog-header.component.js';
import { PurchaseSelection } from '../../common.js';
import { KycWizardComponent } from '../../../kyc-wizard/kyc-wizard.component.js';

declare const Persona: any;

@Component({
  selector: 'app-kyc-purchase',
  imports: [
    CardComponent,
    CardContentComponent,
    PurchaseDialogHeaderComponent,
    KycWizardComponent,
  ],
  templateUrl: './kyc-purchase.component.html',
  styleUrls: ['../styles.scss', './kyc-purchase.component.scss'],
})
export class KycPurchaseComponent {
  readonly close = output<void>();
  readonly back = output<void>();
  readonly continue = output<void>();

  package = input.required<PurchaseSelection>();

  private readonly _auth = inject(AuthService);
  status = signal<'none' | 'pending' | 'approved' | 'rejected'>('none');

  onStatusChange(next: 'none' | 'pending' | 'approved' | 'rejected') {
    this.status.set(next);
  }

  goBack() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.back.emit();
  }
}
